import {Service} from "@/services/superclasses/service";
import {Region} from "@/interfaces/region";

const regionApi = window.contextPath + '/rest/regions';
const countryApi = window.contextPath + '/rest/countries';

export class RegionService extends Service {

    constructor() {
        super()
    }

    public loadById = async (id: number): Promise<Region> => {
        return this.data(await this.get<Region>(regionApi + "/" + id))
    }

    public loadAll = async (country: number): Promise<Region[]> => {
        return this.data(await this.get<Region[]>(countryApi + "/" + country + "/regions"))
    };

    public loadPath = async (id: number): Promise<Region[]> => {
        return this.data(await this.get<Region[]>(regionApi + "/path",
            {
                params: {
                    id
                }
            }))
    };
}

export const regionService = new RegionService()
